import MarkdownView from "../../components/MarkdownView";
import { ScrollView } from "react-native";
import React from "react";
import type { Meta, StoryObj } from "@storybook/react";

const markdownSample1 = `
# Déroulement de la mission

Je suis:
- freelancer
- indépendant
- slasher
- travailleur a temps partiel
- employé
- temporaire
- chômeur

not bold **bold** ~~strike~~ [link](link) **[bold link](link)** __bold again__
<br>

J'ai un client, potentiel employeur, à qui je souhaite envoyer une **proposition de mission**. Rien de plus simple:
<br>
### 1 - Je prépare la proposition
Tu vas d'abord devoir définir les termes de ta mission (client, dates, horaires, rémunération) et pour ta première mission, incule ton permis de travail.
<br>
### 2 - Soumission de la proposition
La Proposition de contrat de misssion est directement envoyée à ton client, après que tu l'aies signée électroniquement.
<br>
### 3 - Acceptation / modification
Ton client pourra te fournir des commentaires pour modifier ta proposition de mission ou l'accepter avec une signature électronique.
<br>
`;

const markdownContent = `
# This is heading 1
## This is heading 2
### This is heading 3
#### This is heading 4
##### This is heading 5
###### This is heading 6

With main body
    
Sub paragraph
    
and more [LINKS](app://test)
- Bullet one
- Bullet two \`with block\`

(c) (C) (r) (R) (tm) (TM) (p) (P) +-

test.. test... test..... test?..... test!....

!!!!!! ???? ,,  -- ---

🚀 to 🪐!

Here we have a text with a contextual help [](help://help-01) that can be pressed.


> [inline](app:/test)

### On image from URL

![Stormtroopocat](https://octodex.github.com/images/stormtroopocat.jpg "The Stormtroopocat")

## Or

![Stormtroopocat=20x20](https://octodex.github.com/images/stormtroopocat.jpg)

\`\`\`
    IMAGE AR NOTE WORKING react-native-fit-image
    ![Stormtroopocat](https://octodex.github.com/images/stormtroopocat.jpg "The Stormtroopocat")
\`\`\`

\`\`\`javascript
const blabla = "This is a block text";
\`\`\`


`;

const StoryComponent = ({
    markdown,
    onLinkPress,
}: {
    markdown: string;
    onLinkPress?: (_: string) => boolean;
}) => {
    return (
        <ScrollView>
            <MarkdownView markdown={markdown} onLinkPress={onLinkPress} />
        </ScrollView>
    );
};

const meta = {
    title: "Components/Markdown",
    component: StoryComponent,
    argTypes: {},
    args: {
        onLinkPress: (url) => {
            // eslint-disable-next-line no-console
            console.log("Link pressed", url);
            return true;
        },
    },
    decorators: [
        (StoryFn) => (
            <ScrollView style={{ padding: 20 }}>
                <StoryFn />
            </ScrollView>
        ),
    ],
} satisfies Meta<typeof MarkdownView>;

export default meta;

type Story = StoryObj<typeof meta>;

export const All: Story = {
    args: {
        markdown: markdownContent,
    },
};

export const Sample: Story = {
    args: {
        markdown: markdownSample1,
    },
};
